module.exports = __webpack_public_path__ + "static/media/instagram.6c1f9a91.svg";